import CardDetails from '../store/schema/CardDetails';
import { getGuid } from 'owa-guid';
const hash = require('hash.js');

/**
 * Separate from parseCard because it depends on hashjs,
 * and we want to put the library dependency behind an async boundary.
 */
export default function parseCardFromStringOrObject(
    commonProps: any,
    card: string | object,
    cardSignature: string,
    isAdaptive?: boolean,
    cardId?: string
): CardDetails {
    let cardJson: any;
    let cardHash: string;

    try {
        if (typeof card === 'string') {
            cardJson = JSON.parse(card);
            const hashBuffer = hash.sha256().update(card).digest();
            cardHash = btoa(String.fromCharCode.apply(null, new Uint8Array(hashBuffer)));
        } else {
            cardJson = card;
        }
    } catch (ex) {
        throw new Error(
            '[ActionableMessageCard] RenderCard: unable to cardSerialized property' + ex.message
        );
    }

    return {
        ...commonProps,
        isAdaptiveCard: isAdaptive === undefined ? cardJson.type === 'AdaptiveCard' : isAdaptive,
        cardSignature: cardSignature,
        card: cardJson,
        cardHash: cardHash,
        cardId: cardId || getGuid(),
    };
}
